import { useQuery } from '@tanstack/react-query';
import { getTag, StatusCode } from '@hungryroot/rest';

function key(tagId: number) {
  return ['tag', tagId];
}

interface UseTagOptions {
  enabled?: boolean;
  retry?: boolean | number;
}

export function useTag(tagId: number, options: UseTagOptions = {}) {
  const tagKey = key(tagId);
  return useQuery({
    queryKey: tagKey,
    queryFn: async () => {
      const resp = await getTag(tagId);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
  });
}
